import ROLES, { RoleValues } from 'enums/Roles';
import { FC } from 'react';
import Chip from '../Chip';

type Props = {
  role: RoleValues;
};
const RoleChip: FC<Props> = ({ role }) => {
  switch (role) {
    case 'MENTEE':
      return (
        <Chip color="#3538CD" bgColor="#EEF4FF">
          {ROLES[role]}
        </Chip>
      );
    case 'MENTOR':
      return (
        <Chip color="#027A48" bgColor="#ECFDF3">
          {ROLES[role]}
        </Chip>
      );
    case 'ADMIN':
      return (
        <Chip color="#F7C325" bgColor="#FDF3D3">
          {ROLES[role]}
        </Chip>
      );
    default:
      return null;
  }
};

export default RoleChip;
